import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Help } from '@mui/icons-material';
import { useFirestore } from 'react-redux-firebase';
import moment from 'moment';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: theme.sizes.md.t3,
  },
  headerBox: {
    height: '150px',
    margin: 4,
    padding: 8,
    border: '1px solid #ccc',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleSection: {
    fontSize: theme.sizes.lg.t1,
    fontWeight: 'bold',
  },
  reference: {
    color: '#b5b5b5',
    marginBottom: 4,
    marginRight: 2,
  },
  tag: {
    padding: '0 16px',
    borderRadius: 50,
    color: theme.palette.white.main,
  },
  tagTotal: {
    backgroundColor: '#6E6E6E',
  },
  tagEntregado: {
    backgroundColor: '#65BD6B',
  },
  tagEntregaPendiente: {
    color: '#FFBC3A',
  },
  tagRechazados: {
    color: '#FD7667',
  },
  iconHelp: {
    color: '#ccc',
    marginLeft: 4,
  },
  iconHelpEntregaPendiente: {
    '&:hover': {
      color: '#FFBC3A',
    },
  },
  iconHelpRechazados: {
    '&:hover': {
      color: '#FD7667',
    },
  },
}));

function Info(props) {
  const classes = useStyles();
  const firestore = useFirestore();
  const [data, setData] = useState();
  const organization = useSelector((state) => state.app.organization);

  useEffect(() => {
    if (organization && organization.id) {
      firestore
        .collection('configurations')
        .where('organizationId', '==', organization.id)
        .where('name', '==', 'notifications')
        .limit(1)
        .get()
        .then((res) => {
          // eslint-disable-next-line no-unused-vars
          let config;
          if (!res.empty) {
            res.forEach((e) => (config = e.data()));
            const data = config.notifications.find((e) => e.date === moment().format('YY/MM'));
            if (data) {
              setData(data);
            }
          }
        });
    }
  }, [firestore, organization, organization.id]);

  const delivered = (data && data.delivered) || 0;
  const pending = (data && data.pending) || 0;
  const failed = (data && data.failed) || 0;
  const total = (data && data.total) || 0;

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={3}>
          <Box className={classes.headerBox}>
            <Typography className={classes.titleSection}>{total}</Typography>
            <Typography className={classes.reference}>WSP</Typography>
            <Typography className={`${classes.tag} ${classes.tagTotal}`}>Total</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box className={classes.headerBox}>
            <Typography className={classes.titleSection}>
              {delivered > 0 ? ((delivered / total) * 100).toFixed(2) : 0}%
            </Typography>
            <Typography className={classes.reference}>{delivered}</Typography>
            <Typography className={`${classes.tag} ${classes.tagEntregado}`}>Entregado</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box className={classes.headerBox}>
            <Box display="flex" justifyContent="center" my={1}>
              <Typography className={classes.reference}>
                {pending} ({pending > 0 ? ((pending / total) * 100).toFixed(2) : 0}
                %)
              </Typography>
              <Typography className={classes.tagEntregaPendiente}>Entrega pendiente</Typography>
              <Help className={`${classes.iconHelp} ${classes.iconHelpEntregaPendiente}`} />
            </Box>
            <Box display="flex" justifyContent="center" my={1}>
              <Typography className={classes.reference}>
                {failed} ({failed > 0 ? (total === 0 ? '0' : (failed / total) * 100).toFixed(2) : 0}
                %)
              </Typography>
              <Typography className={classes.tagRechazados}>Rechazados</Typography>
              <Help className={`${classes.iconHelp} ${classes.iconHelpRechazados}`} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

const Props = {};

Info.propTypes = Props;

export default Info;
